import { useState, useEffect } from 'react';
import { contextsService } from '@/services/contexts';
import { Context, ContextQueryParams } from '@/types/contexts';

export const useContexts = (params?: ContextQueryParams) => {
  const [contexts, setContexts] = useState<Context[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchContexts = async () => {
    try {
      setLoading(true);
      const defaultParams: ContextQueryParams = {
        offset: 0,
        limit: 100,
        ...params
      };
      const response = await contextsService.getAll(defaultParams);
      setContexts(response.data || []);
      setTotal(response.total || 0);
      setError(null);
    } catch {
      setError('Failed to load contexts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContexts();
  }, [params]);

  return { contexts, total, loading, error, refetch: fetchContexts };
};
